import * as Yup from 'yup';

import { ECustomerSearchTypes } from './initialValues';

const FilterSchema = Yup.object().shape({
  customer: Yup.string()
    .nullable()
    .when('customer_type', {
      is: ECustomerSearchTypes.EMAIL,
      then: Yup.string().email('Campo não é um e-mail válido')
    })
    .when('customer_type', {
      is: ECustomerSearchTypes.NAME,
      then: Yup.string().min(5, 'Insira pelo menos 5 caracteres')
    })
});

export default FilterSchema;
